import { PlatformName } from '../types/common.js';
import { useAllIntegrations } from './useAllIntegrations.js';
import {
  useIntegrationAccountTypeRouteApi,
  useIntegrationLayoutRouteApi,
} from './useIntegrationsRouteApi.js';

export const useSelectedIntegration = () => {
  const { integration: routeIntegration } =
    useIntegrationLayoutRouteApi().useParams();

  const integrationName = (
    routeIntegration === 'ga4' ? 'google_analytics' : routeIntegration
  ) as PlatformName;

  const { id } = useIntegrationAccountTypeRouteApi().useSearch();

  const allIntegrations = useAllIntegrations();

  const getIntegration = (id?: string) => {
    return (
      allIntegrations[integrationName]?.find(
        (item: Record<string, unknown>) => Number(item.id) === Number(id),
      ) || {}
    );
  };

  return {
    selectedIntegration: getIntegration(id),
    selectedIntegrationLoading: allIntegrations.loading[integrationName],
  };
};
